import header from '../modules/header/index';
import initInfoGallery from '../modules/initInfoGallery';
import addHightToImageGalery from '../modules/addHightToImageGalery';
import productTooltipControl from '../modules/productTooltipControl';
import addScrollToTop from '../modules/addScrollToTop';
import NewsletterAction from '../modules/newsletterAction';
import tabPanel from '../modules/tabPanel/tabPanelIndex';
import asideMobileOpener from '../modules/asideMobileOpener';
import initAndra from '../modules/initAndra';
import {Apptus} from '../modules/apptus/apptus';
import GoToTabById from '../modules/goToTabById';
import viewModeMobileHandler from '../modules/header/components/viewModeMobileHandler';
import initMainBanner from '../modules/initMainBanner';
import passiveListenersForJquery from '../modules/passiveListenersForJquery';

import "../../../scss/pages/categoryPage.scss";

jQuery(function() {
  passiveListenersForJquery();
  header();
  initInfoGallery();
  addHightToImageGalery();
  productTooltipControl();
  addScrollToTop();
  asideMobileOpener();
  initAndra();
  tabPanel();
  viewModeMobileHandler();
  initMainBanner();

  // Add the aria-label attribute to owl-dot buttons
  $('.owl-carousel').each(function() {
    $(this).find('.owl-dot').each(function(index) {
      $(this).attr('aria-label', index + 1);
    });
  });

  $('.subscription').on('click', function() {
      NewsletterAction($(this));
  });

  if (window.innerWidth <= 767) {
    $('#sidebar').appendTo('.mobile-filter-block');
    $('.ctrl-container.search-panel').prependTo('.drop-container');
  } else {
    $('#sidebar').prependTo('#twocolumns');
    if ($('#sidebar .ctrl-container.search-panel').length) {
      $('.ctrl-container.search-panel').insertAfter('.tab-panel');
    }
  }

  $('.show-more-func').on('click', function(){
    GoToTabById($('.show-more-func').attr('data-more'))
  })
  
  $('.hlPriceRangeFilter').on('click', function(){
    GoToCategoryWithPriceRange();
  })

  $(".btn-back").not(".no-history").on("click", function () {
    history.back();
  });

  $(".btn-back.no-history").on('click', function() {
    $(this).parent().find("li").show();
    $(this).hide();
  })
  $(window).on('click', (e) => {
    let target = e.target;
    var targetParent = $(target).parent();
    if(target.matches('.update-apptus-func') ) {
        Apptus.NotifyClick($(target).attr('data-apptus'))
    }
    if(targetParent.hasClass('update-apptus-func') ) {
        Apptus.NotifyClick($(targetParent).attr('data-apptus'))
    }
  })
  
  function GoToCategoryWithPriceRange() {
    const currentCategoryPriceRangeUrl = $('#divPriceRange').data('url') + '?priceRangeFacet={0}-{1}';
    
    let priceRangeStart = $('.tbPriceRangeStart').val();
    let priceRangeEnd = $('.tbPriceRangeEnd').val();
    
    priceRangeStart = priceRangeStart == null || priceRangeStart === '' ? 0 : priceRangeStart;
    priceRangeEnd = priceRangeEnd == null || priceRangeEnd === '' ? 999999 : priceRangeEnd;
    
    const url = currentCategoryPriceRangeUrl.replace('{0}', priceRangeStart).replace('{1}', priceRangeEnd);
    window.location.href = url;
  }
})
